module.exports = __webpack_public_path__ + "static/media/telemed.8c5b5c82.png";